import { useQuery } from '@apollo/react-hooks'
import { gql } from 'apollo-boost'
import {
  PlusSubscriptionV2Query,
  PlusSubscriptionV2QueryVariables
} from './__generated__/PlusSubscriptionV2Query'

export const PLUS_SUBSCRIPTION_V2_QUERY = gql`
  query PlusSubscriptionV2Query($boardId: String!) {
    plusSubscriptionV2(boardId: $boardId) {
      ... on PlusSubscriptionV2 {
        id
        subscriptionId
        paymentProvider
        currentPeriodEnd
        currentPeriodStart
        subscriptionCreated
        startDate
        canceledAt
        cancelAt
        endedAt
        trialStart
        trialEnd
        billingCycleAnchor
        billingInformation {
          cardBrand
          cardLast4
          interval
          intervalCount
          nextBillingDate
          activationDate
          cancellationDate
          purchaserEmail
          activationCode
        }
      }
      ... on PlusSubscriptionErrorV2 {
        error
        type
      }
    }
  }
`

export const usePlusSubscriptionV2Query = (boardId: string) =>
  useQuery<PlusSubscriptionV2Query, PlusSubscriptionV2QueryVariables>(PLUS_SUBSCRIPTION_V2_QUERY, {
    variables: { boardId },
    fetchPolicy: 'network-only'
  })
